import { environment } from '../../environments/environment';

// Use the build's API environment, not browser input or a shared Auth0 session.
export const isolatedStagingApp =
  environment.API_BASE_URL.replace(/\/+$/, '') === 'https://app.staging.footballer.zone/api/v0';

export function nativeAppUrl(destination: string): string {
  return `${isolatedStagingApp ? 'footballer-staging' : 'footballer'}://${destination}`;
}

// Staging distribution is invitation-only until its own public channels exist.
// Never offer the production app as a fallback for a staging match.
export const androidAppDownloadUrl = isolatedStagingApp ? ''
  : 'https://play.google.com/store/apps/details?id=com.mangonel.nogosh&hl=en&gl=US';
export const iosAppDownloadUrl = isolatedStagingApp ? ''
  : 'https://apps.apple.com/us/app/footballer-zone/id1312823941';
